module.exports = __webpack_public_path__ + "img/img6.9d1c1080.svg";